type Reporter = (error: unknown) => void;
let reporter: Reporter | undefined;

export const setErrorReporter = (r: Reporter) => {
  reporter = r;
};

export const reportError = (error: unknown) => reporter?.(error);
